export default __webpack_public_path__ + "static/media/gstartup.1eea4a84.svg";